import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export const DashboardCard = ({ children }) => (
  <Card sx={{ padding: '1em', textAlign: 'center', borderRadius: '1.5em' }}>
    <CardContent>{children}</CardContent>
  </Card>
);

export const DashboardLink = ({ children, ...props }) => (
  <Link {...props} color="inherit" underline="none">{children}</Link>
);

export const CardTitle = ({ children }) => (
  <Typography variant="p" component="h3">{children}</Typography>
);

export const DashboardGrid = ({ children }) => (
  <Box
    component="div"
    sx={{
      my: '2em',
      display: 'grid',

      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '1.5em',
    }}
  >
    {children}
  </Box>
);
